module.exports = __webpack_public_path__ + "static/media/cds-home-mobile.9922ca45.jpg";